import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import testIds from "constants/testIds";
import Select from "components/v2/Select/Select";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useEditShipmentLock } from "@RequestFormV2/context/editShipmentLock";
import { useOrganisation } from "@RequestFormV2/sections/Organisation/context";
import { useRequestFormDraftId } from "@RequestFormV2/hooks/useRequestFormDraftId";

export default function LocationDetailsSection() {
  const intl = useIntl();
  const isEditShipmentLock = useEditShipmentLock();
  const draftId = useRequestFormDraftId();
  const { shipmentId } = useParams();
  const { startingPoint, locationOptions, selectedLocation, invoiceLocationDetails } = useOrganisation();
  // A draft (convert/duplicate) or an existing request (edit) brings its own location.
  // Preselecting here would make useRequestFormDraftLoad think that draft is already applied.
  const shouldPreselect = !isEditShipmentLock && !draftId && !shipmentId;

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.organisation.location-details",
          defaultMessage: "Location details",
        })}
        required
      />

      <div className="rfv2-form-section__content">
        <div className="rfv2-two-column-grid">
          <Select
            name="organizational.location"
            label={startingPoint?.label}
            options={locationOptions}
            required
            preselect={shouldPreselect}
            isClearable={!isEditShipmentLock}
            isDisabled={isEditShipmentLock}
            testId={testIds.REQUEST_FORM_ORGANISATION_PAYMENT_LOCATION}
          />

          {selectedLocation && invoiceLocationDetails && (
            <Select
              name="organizational.invoice_location"
              label={invoiceLocationDetails.label}
              options={invoiceLocationDetails.dropdown_values}
              required={invoiceLocationDetails.mandatory}
              placeholder={invoiceLocationDetails.placeholder}
              isClearable
              preselect
              testId={testIds.REQUEST_FORM_ORGANISATION_INVOICE_LOCATION}
            />
          )}
        </div>
      </div>
    </div>
  );
}
